/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { RequestStatus } from './RequestStatus';
import {
    RequestStatusFromJSON,
    RequestStatusFromJSONTyped,
    RequestStatusToJSON,
} from './RequestStatus';

/**
 * 
 * @export
 * @interface InvestmentRequestUpdate
 */
export interface InvestmentRequestUpdate {
    /**
     * 
     * @type {number}
     * @memberof InvestmentRequestUpdate
     */
    requestId: number;
    /**
     * 
     * @type {RequestStatus}
     * @memberof InvestmentRequestUpdate
     */
    status: RequestStatus;
    /**
     * 
     * @type {string}
     * @memberof InvestmentRequestUpdate
     */
    note?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestmentRequestUpdate
     */
    lastUpdatedBy: string;
    /**
     * 
     * @type {string}
     * @memberof InvestmentRequestUpdate
     */
    updatedAt: string;
}



/**
 * Check if a given object implements the InvestmentRequestUpdate interface.
 */
export function instanceOfInvestmentRequestUpdate(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "requestId" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "lastUpdatedBy" in value;
    isInstance = isInstance && "updatedAt" in value;

    return isInstance;
}

export function InvestmentRequestUpdateFromJSON(json: any): InvestmentRequestUpdate {
    return InvestmentRequestUpdateFromJSONTyped(json, false);
}

export function InvestmentRequestUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvestmentRequestUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'requestId': json['request_id'],
        'status': RequestStatusFromJSON(json['status']),
        'note': !exists(json, 'note') ? undefined : json['note'],
        'lastUpdatedBy': json['last_updated_by'],
        'updatedAt': json['updated_at'],
    };
}

export function InvestmentRequestUpdateToJSON(value?: InvestmentRequestUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'request_id': value.requestId,
        'status': RequestStatusToJSON(value.status),
        'note': value.note,
        'last_updated_by': value.lastUpdatedBy,
        'updated_at': value.updatedAt,
    };
}

